import { RouterProvider } from 'react-router-dom';
import { QueryClientProvider } from '@sib/api';
import { I18nextProvider } from '@sib/i18n';
import { i18n } from '@sib/i18n';
import { NotificationProvider } from '@sib/notifications';
import { TooltipProvider } from '@sib/ui';
import '@sib/ui/styles';
import { ThemeProvider } from './providers/theme-provider';
import { routerInstance } from './App.routes';

function App() {
  return (
    <I18nextProvider i18n={i18n}>
      <QueryClientProvider>
        <ThemeProvider>
          <TooltipProvider
            delayDuration={0}
            skipDelayDuration={0}
            disableHoverableContent={true}
          >
            <NotificationProvider>
              <RouterProvider router={routerInstance} />
            </NotificationProvider>
          </TooltipProvider>
        </ThemeProvider>
      </QueryClientProvider>
    </I18nextProvider>
  );
}

export default App;
